import "../styles.css";
import { initializePage } from "./dom/dom";
import User from "./user";

const currentUser = new User();

initializePage(currentUser);
